import './styles/component.artist-card-shop.scss';
import { algoliaClient } from '../api/algolia/algolia.client';
import { getLazyLinkToImage } from '../utils/getLazyLinkToImage';
import { isNullOrUndef } from '../utils/isNullOrUndef';
import { dlItemsViewListEvent } from '../events/dl.Items.viewList.event';
import { algoliaClickHit } from '../algolia-react/events/algolia.clickHit';
const vn = window.vNode;
const algIndex = 'pc_collections_popular';
const CLIENT = algoliaClient('K2CTT24UP3', '2ddbb0a8db153957543d851ca677c689');
const INDEX = CLIENT.initIndex(algIndex);
const itemsPerCard = 3;
const itemsToRetrieve = itemsPerCard * 2;
const getItems = async (filters) => {
    const response = await INDEX.search('', {
        analytics: true,
        clickAnalytics: true,
        hitsPerPage: itemsToRetrieve,
        page: 0,
        filters,
        responseFields: ['hits'],
        attributesToRetrieve: [
            'square_image',
            'title',
            'url',
            'shopify_id'
        ]
    });
    return [response.hits, response.queryID];
};
void (async () => {
    const productsWrapperArr = document.querySelectorAll('.artistProductsJS');
    const listForEvent = [];
    for (const wrapper of productsWrapperArr) {
        const collectionTitle = wrapper.dataset.cTitle;
        const filters = window.algFiltersForArtistsProducts?.[collectionTitle ?? ''];
        if (filters === undefined)
            continue;
        const [hits, queryID] = await getItems(filters);
        if (isNullOrUndef(hits))
            continue;
        listForEvent.push({
            name: collectionTitle,
            filter: filters,
            type: 'artist'
        });
        let imagesCount = 0;
        wrapper.innerHTML = '';
        for (const hit of hits) {
            if (imagesCount === itemsPerCard) {
                imagesCount = 0;
                break;
            }
            if (isNullOrUndef(hit.square_image) || hit.square_image === '')
                continue;
            ++imagesCount;
            const lazySrc = getLazyLinkToImage(hit.square_image);
            vn.mount({
                vNode: vn.create('li', vn.create('a', {
                    class: 'skeleton d:block pos:r image-wrapper bdrs:2 ov:h',
                    href: hit.url,
                    title: hit.title,
                    events: {
                        click: () => {
                            algoliaClickHit({
                                index: algIndex,
                                collectionName: collectionTitle,
                                collectionType: 'artist',
                                position: imagesCount,
                                queryID,
                                hit: {
                                    ...hit,
                                    sku: hit.objectID
                                }
                            });
                        }
                    }
                }, vn.create('img', {
                    class: 'pos:a l:0 t:0 trs trs:du:600 image:cover',
                    loading: 'lazy',
                    sizes: '(max-width: 400px) 204px, ((min-width: 768px) and (max-width: 1200px)) 219px, 405px',
                    srcset: ['160', '320', '640', '960'].reduce((str, curr, i) => {
                        return `${str}${i === 0 ? '' : ','} ${lazySrc.replace('{width}', curr)} ${curr}w`;
                    }, ''),
                    src: hit.square_image,
                    alt: hit.title
                }))),
                container: wrapper
            });
        }
    }
    dlItemsViewListEvent(listForEvent);
})();
